import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import StructuredData from '@/components/feature/StructuredData';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import DailyNews from './components/DailyNews';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';
import { faqs, articles } from '@/mocks/articles';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '911爆料网',
  alternateName: '911黑料网',
  url: 'https://www.911baoliao.com/',
  description: '911爆料网是全网吃瓜黑料第一站入口，每日更新网红翻车塌房实锤、反差视频高清资源、明星八卦独家爆料与每日大赛最新动态。',
  inLanguage: 'zh-CN',
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '911爆料网',
  alternateName: '911黑料网',
  url: 'https://www.911baoliao.com/',
  description: '全网吃瓜黑料第一站入口',
  sameAs: ['https://weibo.com/911baoliao', 'https://www.toutiao.com/911baoliao'],
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

export default function Home() {
  return (
    <>
      <StructuredData data={websiteSchema} />
      <StructuredData data={organizationSchema} />
      <StructuredData data={faqSchema} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <Hero />
          <CategoryNav />
          <DailyNews />
          <Testimonials />
          <FAQ />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}